// routing
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LogInOutComponent } from "./security/loginout/loginout.component";
import { ErrorComponent } from './error/error.component';
import { PageNotFoundComponent } from './error/page-not-found.component';
import { CurrentUserComponent } from './security/current-user/current-user.component';
import { FacetedSearchAppComponent } from './fsapplication/faceted-search-app/faceted-search-app.component';
import { AdminFacetsComponent } from "./fsapplication/admin-facets/admin-facets.component";
import { AdminAppComponent } from './fsapplication/admin-app/admin-app.component';
import { AdminAboutComponent } from './fsapplication/admin-about/admin-about.component';
import { AdminPresetsComponent } from "./fsapplication/admin-presets/admin-presets.component";


const appRoutes: Routes = [
  {
    path: '',
    component: FacetedSearchAppComponent
  }
  ,
  {
    path: 'userinfo',
    component: CurrentUserComponent
  }
  ,
  {
    path: 'adminfacets',
    component: AdminFacetsComponent
  }
  ,
  {
    path: 'settings',
    component: AdminAppComponent
  }
  ,
  {
    path: 'presets',
    component: AdminPresetsComponent
  }
  ,
  {
    path: 'about',
    component: AdminAboutComponent
  }
  ,
  {
    path: 'error',
    component: ErrorComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule],
  providers: [],
})

export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app.routing.ts